'use strict';

// TODO development webpack4 require(@pengchen/xlsx)有问题
// if (process.env.NODE_ENV === 'production') {
module.exports = require('./dist/table-xlsx.production.js');
// } else {
//   module.exports = require('./dist/table-xlsx.development.js');
// }



//////////////////
// WEBPACK FOOTER
// ./node_modules/table-xlsx/index.js
// module id = FVhy
// module chunks = 416